import type { UIFacet } from 'src/components/types/UIFacet';
import type { Facet } from 'src/redux/productsQuery/types/Facet';

export const adaptFacetToUIFacet = (facets: Facet[]): UIFacet[] => {
  const facetsWithProducts = facets.filter((facet) =>
    facet.options.some((option) => option.count !== 0),
  );

  return facetsWithProducts.map((facet) => {
    return {
      alias: facet.alias,
      key: facet.key,
      options: facet.options.map((option) => {
        return {
          active: option.active,
          count: option.count,
          title: option.title,
          value: option.value,
          custom: option.custom,
        };
      }),
      title: facet.title || '',
      type: facet.type,
      ...(facet.singleOptionOnly === true ? { singleOptionOnly: true } : {}),
    };
  });
};
